/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:20:14
 * @LastEditTime: 2020-03-27 11:20:25
 */
// ==== cookie  cookie操作相关
var cookie = {
  /**
     * 设置cookie
     * @param {string} sName cookie名
     * @param {string} sValue cookie值
     * @param {int} iExpireSec 失效时间（秒）
     * @param {string} sDomain 作用域
     * @param {string} sPath 作用路径
     * @param {bool} bSecure 是否加密
     * @return {void}
     */
  set: function set(sName, sValue, iExpireSec, sDomain, sPath, bSecure) {
    if (sName == undefined) {
      return;
    }

    if (sValue == undefined) {
      sValue = '';
    }

    var oCookieArray = ["".concat(sName, "=").concat(escape(sValue))];

    if (!isNaN(iExpireSec)) {
      var oDate = new Date();
      oDate.setTime(oDate.getTime() + iExpireSec * 1000);
      iExpireSec == 0 ? '' : oCookieArray.push("expires=".concat(oDate.toGMTString()));
    }

    if (sDomain != undefined) {
      oCookieArray.push("domain=".concat(sDomain));
    }

    if (sPath != undefined) {
      oCookieArray.push("path=".concat(sPath));
    }

    if (bSecure) {
      oCookieArray.push('secure');
    }

    document.cookie = oCookieArray.join('; ');
  },

  /**
     * 获取cookie
     * @param {string} sName cookie名
     * @param {string} sValue 默认值
     * @return {string} cookie值
     */
  get: function get(sName, sDefaultValue) {
    var sRE = "(?:; |^)".concat(sName, "=([^;]*);?");
    var oRE = new RegExp(sRE);

    if (oRE.test(document.cookie)) {
      return unescape(RegExp.$1);
    }

    return sDefaultValue || null;
  },

  /**
     * 获取cookie
     * @param {string} sName cookie名
     * @param {string} sDomain 作用域
     * @param {sPath} sPath 作用路径
     * @return {void}
     */
  clear: function clear(sName, sDomain, sPath) {
    var oDate = new Date();
    cookie.set(sName, '', -oDate.getTime() / 1000, sDomain, sPath);
  }
};
export default cookie;